<template>
  <transition name="fade-slide">
    <div v-if="isVisible" class="a2hs-overlay">
      <div class="overlay-content">
        <div class="header">
          <div class="title">Install ShootDay Crew Connect</div>
          <button class="close-btn" @click="dismiss">
            <close-outlined />
          </button>
        </div>
        <div class="body">
          <p>Install this app on your home screen for quick and easy access.</p>
          <div class="steps">
            <div class="step">
              <span class="step-number">1</span>
              <span>Tap the share button </span>
              <span class="share-icon-wrapper">
                <export-outlined class="share-icon" />
              </span>
            </div>
            <div class="step">
              <span class="step-number">2</span>
              <span>Scroll down and tap <b>'Add to Home Screen'</b></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { CloseOutlined, ExportOutlined } from '@ant-design/icons-vue'

const isVisible = ref(false)

const checkPWAStatus = () => {
  const isIos =
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  const isStandalone =
    'standalone' in window.navigator && (window.navigator as any).standalone
  const isDismissed = localStorage.getItem('pwa_prompt_dismissed') === 'true'

  if (isIos && !isStandalone && !isDismissed) {
    isVisible.value = true
  }
}

const dismiss = () => {
  isVisible.value = false
  localStorage.setItem('pwa_prompt_dismissed', 'true')
}

onMounted(() => {
  // Delay showing the overlay slightly for better UX
  setTimeout(checkPWAStatus, 2000)
})
</script>

<style scoped lang="scss">
.a2hs-overlay {
  position: fixed;
  top: 100px;
  left: 20px;
  right: 20px;
  background: var(--color-background-soft);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.overlay-content {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .title {
    font-weight: 700;
    font-size: 1.1rem;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.body {
  p {
    margin: 0 0 16px 0;
    font-size: 0.95rem;
    line-height: 1.4;
  }
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .step {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.9rem;

    .step-number {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      flex-shrink: 0;
    }
  }
}

.share-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  margin: 0 4px;
}

.share-icon {
  font-size: 1.1rem;
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
